// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mic-wave-wrapper {
    width: 100%;
    height: 60px;
    background-color: white;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  
  .mic-wave-canvas {
    width: 100%;
    height: 100%;
    display: block;
  }
  `, "",{"version":3,"sources":["webpack://./src/Shared/Components/MicWaveAnimation/MicWaveAnimation.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB","sourcesContent":[".mic-wave-wrapper {\n    width: 100%;\n    height: 60px;\n    background-color: white;\n    border-radius: 12px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n  }\n  \n  .mic-wave-canvas {\n    width: 100%;\n    height: 100%;\n    display: block;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
